import { profileService } from './profile.js';
export const services = {
    profile: profileService,
};
